import ActionType from './ActionType';

export function signedIn(state = false, action) {
  switch(action.type) {
    case ActionType.SIGN_IN:
      return true;

    case ActionType.RESET:
      return false;

    default:
      return state;
  }
}

export function credentials(state = null, action) {
  switch(action.type) {
    case ActionType.SIGN_IN:
      return action.token;

    case ActionType.RESET:
      return null;

    default:
      return state;
  }
}

export function user(state = {}, action) {
  switch(action.type) {
    case ActionType.SIGN_IN:
    case ActionType.SET_USER:
      return action.user;

    case ActionType.UPDATE_SETTING:
      return {
        ...state,
        settings: [
          ...(state.settings ? state.settings.filter(setting => setting.key !== action.key) : []),
          {key: action.key, value: action.value}
        ]
      };

    case ActionType.RESET:
      return {};

    default:
      return state;
  }
}

export function notificationCount(state = 0, action) {
  switch (action.type) {
    case ActionType.UPDATE_NOTIFICATION_COUNT:
      return action.count;
    
    case ActionType.RESET:
      return 0;

    default:
      return state;
  }
}

export function labels(state = {}, action) {
  switch (action.type) {
    case ActionType.UPDATE_COMPANY_SETTINGS:
      return action.labels;
    
      case ActionType.RESET:
        return {};
    
    default: 
      return state;
  }
}

export function logo(state = null, action) {
  switch (action.type) {
    case ActionType.UPDATE_COMPANY_LOGO:
      return action.logo;
    
      case ActionType.RESET:
        return null;
    
    default: 
      return state;
  }
}
